var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.96 222.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;font-family:HelveticaNeue-Bold, 'Helvetica Neue';font-size:72px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 80.98,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,99.73c-9.01,4.68-19.24,7.33-30.1,7.33s-21.08-2.66-30.1-7.33C21.83,105.81,0,131.57,0,162.43v19.34c0,16.3,13.21,29.51,29.51,29.51h102.94c16.3,0,29.51-13.21,29.51-29.51v-19.34c0-30.86-21.83-56.62-50.88-62.7Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(60.96 187.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserQuestionMark);
export default __webpack_public_path__ + "static/media/user-question-mark.f036a323119aaa8db1459c7cd916e202.svg";
export { ForwardRef as ReactComponent };